import { any, bool, number } from 'prop-types'
import { forwardRef, memo } from 'react'

const HeaderRow = memo(
   forwardRef(
      (
         { label = '', index = 0, withPadding = true, isSticky = false, isLastSticky = false, stickyLeft = 0 },
         ref,
      ) => (
         <th
            ref={ref}
            data-padding={withPadding}
            data-sticky={isSticky}
            data-sticky-last={isLastSticky}
            style={isSticky ? { left: stickyLeft } : undefined}
            title={typeof label === 'string' ? label : undefined}
         >
            {label}
         </th>
      ),
   ),
)

HeaderRow.propTypes = {
   index: number,
   isLastSticky: bool,
   isSticky: bool,
   label: any,
   stickyLeft: number,
   withPadding: bool,
}

export default HeaderRow